import { cn } from "@repo/ui/utils"

import styles from "./statement.module.css"

// A 'statement', the text on the homepage tied to an animation state
// for the dot field
export function Statement(props: React.ComponentProps<"div"> & { current: string | null }) {
  return (
    <div className={cn(`${styles["container"]}`, props.className)} {...props}>
      {props.children}
    </div>
  )
}
